export function initShareLinks() {
    const elements = $('.share-button');
    elements.click(function () {
        const data = $(this).data('share');
        let shareData = data;
        if (data === '__current') {
            shareData = location.protocol + '//' + location.hostname + location.pathname;
        }

        navigator.clipboard.writeText(shareData)
            .then(() => {
                $(this).addClass('share-button-clicked');
            });
    });
}

export function initBranchSearch() {
    const input = $('#branch-title');
    const container = $('.branch-list');
    const rows = container.find('tr');
    container.find('.branch-list-search').submit(function (e) {
        e.preventDefault();
        const search = input.val().toLowerCase();
        rows.each(function () {
            const text = $(this).text().toLowerCase();
            $(this).toggleClass('branch-list-item-hidden', !text.includes(search));
        });
    });
}

export function initOfferSearch() {
    const input = $('#offer-title');
    const container = $('.offer-list');
    const rows = container.find('tr');
    container.find('.offer-list-search').submit(function (e) {
        container.addClass('offer-list--searched');

        e.preventDefault();
        const search = input.val().toLowerCase();
        rows.each(function () {
            const text = $(this).text().toLowerCase();
            $(this).toggleClass('offer-list-item-hidden', !text.includes(search));
        });

        if (search === '') {
            container.removeClass('offer-list--searched');
        }
    });

    container.find('.offer-list-search-reset').click(function () {
        container.removeClass('offer-list--searched');
        input.val('');

        rows.each(function () {
            $(this).removeClass('offer-list-item-hidden');
        });
    });
}

export function hideMobileAds() {
    if (window.innerWidth <= 600) {
        $('.not-ad-container').parent().hide();
    }
}